import { render, staticRenderFns } from "./PasswordResetDialog.vue?vue&type=template&id=dcd67d2c&scoped=true"
import script from "./PasswordResetDialog.vue?vue&type=script&lang=ts"
export * from "./PasswordResetDialog.vue?vue&type=script&lang=ts"
import style0 from "./PasswordResetDialog.vue?vue&type=style&index=0&id=dcd67d2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd67d2c",
  null
  
)

export default component.exports